import { render, staticRenderFns } from "./ViewApp.vue?vue&type=template&id=b221e86e&scoped=true"
import script from "./ViewApp.vue?vue&type=script&lang=js"
export * from "./ViewApp.vue?vue&type=script&lang=js"
import style0 from "./ViewApp.vue?vue&type=style&index=0&id=b221e86e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b221e86e",
  null
  
)

export default component.exports